import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { createPageUrl } from "@/utils";
import deadEntertainmentLogo from "@/assets/white_ooutline_dead_ent_png-removebg-preview.png";
import soundopeLogo from "@/assets/soundope-purple-blue-logo.png";
import SupportModal from "@/components/SupportModal";

export default function Footer({ onDeadEntLogoClick = () => {}, onSoundopeLogoClick = () => {} }) {
  return (
    <footer className="border-t border-[#1f1f1f] bg-[#0a0a0a] py-8 px-4 mt-12">
      <div className="max-w-screen-xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex flex-col items-start gap-2 mb-4">
              <button
                onClick={onSoundopeLogoClick}
                className="cursor-pointer hover:opacity-80 transition-opacity"
                type="button"
                aria-label="Soundope logo"
              >
                <img
                  src={soundopeLogo}
                  alt="Soundope"
                  className="h-24 md:h-32 object-contain"
                />
              </button>
            </div>
            <p className="text-xs text-[#707070] leading-relaxed">
              Free playlist submissions, Free unbiased feedback. Get heard, be absurd. Dope sounds @ soundope.
            </p>
            <div className="mt-3">
              <p className="text-xs text-[#707070] mb-2">
                soundope is owned and operated by -
              </p>
              <div className="flex flex-col items-start gap-2">
                <button
                  onClick={onDeadEntLogoClick}
                  className="cursor-pointer hover:opacity-80 transition-opacity"
                  type="button"
                  aria-label="Dead Entertainment LLC logo"
                >
                  <img
                    src={deadEntertainmentLogo}
                    alt="Dead Entertainment LLC"
                    className="h-24 md:h-32 object-contain"
                  />
                </button>
              </div>
            </div>
          </div>

          {/* Become a Curator */}
          <div>
            <h3 className="text-sm font-medium text-[#d0d0d0] mb-4">APPLY TO BE A CURATOR</h3>
            <p className="text-xs text-[#808080] mb-3">in 3 EASY steps</p>
            <ol className="text-xs text-[#707070] space-y-2 list-decimal list-inside">
              <li>create an account</li>
              <li>upload an active playlist.</li>
              <li>email support@soundope.com with the name of your account/email address</li>
            </ol>
          </div>


          {/* Resources */}
          <div>
            <h3 className="text-sm font-medium text-[#d0d0d0] mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to={createPageUrl("HowItWorks")} className="text-xs text-[#808080] hover:text-[#a0a0a0]">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to={createPageUrl("ForArtists")} className="text-xs text-[#808080] hover:text-[#a0a0a0]">
                  For Artists
                </Link>
              </li>
              <li>
                <Link to={createPageUrl("FAQ")} className="text-xs text-[#808080] hover:text-[#a0a0a0]">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to={createPageUrl("Report")} className="text-xs text-[#808080] hover:text-[#a0a0a0]">
                  Report an Issue
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-xs text-[#808080] hover:text-[#a0a0a0]">
                  Blog
                </Link>
              </li>
              <li>
                <SupportModal />
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-medium text-[#d0d0d0] mb-4">Legal</h3>
            <ul className="space-y-0.5">
              <li>
                <Link to={createPageUrl("EULA")} className="text-xs text-[#808080] hover:text-[#a0a0a0]">
                  End User License Agreement
                </Link>
              </li>
              <li>
                <Link to={createPageUrl("TOS")} className="text-xs text-[#808080] hover:text-[#a0a0a0]">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to={createPageUrl("PrivacyPolicy")} className="text-xs text-[#808080] hover:text-[#a0a0a0]">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to={createPageUrl("CookiePolicy")} className="text-xs text-[#808080] hover:text-[#a0a0a0]">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to={createPageUrl("Disclaimer")} className="text-xs text-[#808080] hover:text-[#a0a0a0]">
                  Disclaimer
                </Link>
              </li>
              <li>
                <Link to={createPageUrl("AcceptableUsePolicy")} className="text-xs text-[#808080] hover:text-[#a0a0a0]">
                  Acceptable Use Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </footer>
  );
}

Footer.propTypes = {
  onDeadEntLogoClick: PropTypes.func,
  onSoundopeLogoClick: PropTypes.func,
};
